import { Injectable } from '@angular/core';
import {LoadingController} from "@ionic/angular/standalone";
import {from} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loading: HTMLIonLoadingElement | undefined;
  private isLoading = false;

  constructor(
    private loadingCtrl: LoadingController
  ) { }

  async showLoader(message?: string) {
    if(!this.isLoading) {
      this.isLoading = true;
      const msg = message ?? 'Caricamento in corso...';
      this.loading = await this.loadingCtrl.create({
        spinner: 'bubbles',
        message: msg,
        cssClass: 'loader',
        htmlAttributes: { 'aria-label': msg }
      });
      return this.loading.present();
    }
    return new Promise<boolean>((resolve) => resolve(true));
  }

  async startInvisibleLoader() {
    if(!this.isLoading) {
      this.isLoading = true;
      this.loading = await this.loadingCtrl.create({
        spinner: null,
        cssClass: 'invisible-loader',
        showBackdrop: false,
        htmlAttributes: { 'aria-label': 'Caricamento in corso' }
      });
      return this.loading.present();
    }
    return new Promise<boolean>((resolve) => resolve(true));
  }


  hideLoader() {
    this.loading?.dismiss();
    this.isLoading = false;
  }

  showLoaderObserve$(message?: string){
    return from(this.showLoader(message));
  }

  showInvisibleLoaderObserve$(){
    return from(this.startInvisibleLoader());
  }
}
